"use client";

import { useNotifications } from "@tosize/ui";
import { useBetterAction } from "~/hooks/useBetterAction";
import { useRouter } from "~/hooks/useRouter";
import { type AddItemSchemaType, addItem } from "../actions/item/add";
import { datalayerAddToCart } from "./datalayer";
import type { AddToCartMessagesType } from "./getAddToCartMessages";

export function useAddToCart(props: AddToCartMessagesType) {
	const router = useRouter();
	const { notify } = useNotifications();

	const { executeAsync, isPending } = useBetterAction(addItem);

	const handleAddItem = async (input: AddItemSchemaType) => {
		const response = await executeAsync(input);

		if (!(response instanceof Error) && response?.data?.item) {
			datalayerAddToCart(response.data.item);

			notify({
				variant: "success",
				title: `${response.data.item.name} ${props.added}`,
				subtitle: response.data.item.parent ? props.viewParent : props.view,
				action: {
					altText: props.action,
					onClick: () => void router.push("/cart"),
				},
			});
		}
	};

	return { handleAddItem, addingItem: isPending } as const;
}
